<div class="container">
  <!-- HEADER -->
  <div class="header">
    <div class="header-text">
      <span class="welcome">Olá, {{user?.nome}} 👋</span>
      <h1>{{ treino?.nome || (semTreino ? 'Sem treino hoje' : '') }}</h1>
    </div>
    <div class="header-actions">
      <button [routerLink]="['/treino-dashboard']" class="btn-dashboard" placement="top" ngbTooltip="Dashboard">
        <i class="bi bi-bar-chart"></i>
      </button>
      <button [routerLink]="['/treino-gestao']" class="btn-config" placement="top" ngbTooltip="Gerenciar treino">
        <i class="bi bi-gear"></i>
      </button>
    </div>
  </div>

  <!-- SEM TREINO -->
  @if (semTreino) {
  <div class="card sem-treino">
    <i class="bi bi-calendar-x"></i>
    <p>Não há treino para hoje.</p>
  </div>
  }

  <!-- FORM (com treino) -->
  <ng-container *ngIf="form && !semTreino" [formGroup]="form">
    <!-- EXERCÍCIOS -->
    <div class="card">
      <div class="row">
        <div class="col">
          <h2>Exercícios</h2>
        </div>
        <div class="col-1"><span class="badge text-bg-primary align-middle">{{ exerciciosFA.length }}</span></div>
      </div>

      @if(exerciciosFA.length > 0){
      <div formArrayName="exercicios">
        <div *ngFor="let ex of exerciciosFA.controls; let i = index" [formGroupName]="i" class="item row">
          <!-- INFO -->
          <div class="info col-12">
            <div class="row align-items-center">
              <div class="nome-exercicio col-md-6 col-12">
                {{ exercicios[i].nome }} ({{ exercicios[i].tipo }})
              </div>
              <div class="col-md-3 col-4">
                <b>Séries:</b> {{ exercicios[i].series }}
              </div>
              <div class="col-md-3 col-4">
                <b>Reps:</b> {{ exercicios[i].repeticoes }}
              </div>
            </div>
            <!-- STEPPER CARGA -->
            <div class="stepper-group mt-2">
              <label class="stepper-label"><b>Carga</b></label>
              <div class="stepper">
                <button type="button" class="stepper-btn" (pointerdown)="startHold($event, i, -1)"
                  (pointerup)="stopHold()" (pointerleave)="stopHold()" (pointercancel)="stopHold()"
                  [disabled]="$safeNavigationMigration(ex.get('cargaEfetuada')?.value) <= 0" aria-label="Diminuir carga">
                  <i class="bi bi-dash-lg"></i>
                </button>
                <div class="stepper-value">
                  <b>{{ $safeNavigationMigration(ex.get('cargaEfetuada')?.value) | number:'1.1-1' }}</b>
                  <span class="unit">kg</span>
                </div>
                <button type="button" class="stepper-btn" (pointerdown)="startHold($event, i, 1)"
                  (pointerup)="stopHold()" (pointerleave)="stopHold()" (pointercancel)="stopHold()"
                  aria-label="Aumentar carga">
                  <i class="bi bi-plus-lg"></i>
                </button>
              </div>
            </div>
          </div>
          <!-- MÍDIA -->
          <div class="carousel col-12 mt-2 mt-md-0">
            <iframe *ngIf="exercicios[i].video" [src]="exercicios[i].video | safeUrl" class="media-item video w-100">
            </iframe>
            <img *ngFor="let img of exercicios[i].imagens" [src]="img" class="media-item w-100">
          </div>
        </div>
      </div>
      } @else {
      <p>Nenhum exercício cadastrado para este treino.</p>
      }
    </div>

    <!-- ABDOMINAL -->
    <div class="card">
      <h2>Abdominais</h2>

      @if (abdominaisFA.length > 0){

      <div formArrayName="abdominais">

        <div *ngFor="let ab of abdominaisFA.controls; let i = index" [formGroupName]="i" class="item">

          <div class="nome-exercicio pequeno">
            {{ abdominais[i].nome }}
          </div>

          <div class="row">
            <div class="col-6">
              <label>Séries</label>
              <input type="number" formControlName="series" min="1" class="form-control">
            </div>

            <div class="col-6">
              <label>Repetições</label>
              <input type="number" formControlName="repeticoes" min="1" class="form-control">
            </div>
          </div>

        </div>

      </div>

      } @else {
      <p>Nenhum abdominal cadastrado para este treino.</p>
      }

    </div>

    <!-- CARDIO -->
    <div class="card">
      <h2>Cardio</h2>

      @if (cardiosFA.length > 0){

      <div formArrayName="cardios">

        <div *ngFor="let cd of cardiosFA.controls; let i = index" [formGroupName]="i" class="item">

          <div class="nome-exercicio pequeno">
            {{ cardios[i].nome }}
          </div>

          <div class="row">

            <div class="col-4">
              <label>Km</label>
              <input type="number" formControlName="distanciaKm" step="0.5" class="form-control">
            </div>

            <div class="col-4">
              <label>Min</label>
              <input type="number" formControlName="tempoMinutos" class="form-control">
            </div>

            <div class="col-4">
              <label>Intensidade</label>
              <select formControlName="tipoTreino" class="form-control">
                <option value="leve">Leve</option>
                <option value="moderado">Moderado</option>
                <option value="intenso">Intenso</option>
              </select>
            </div>

          </div>

        </div>

      </div>

      } @else {
      <p>Nenhum treino cardio cadastrado para este treino.</p>
      }

    </div>

    <!-- SALVAR -->
    @if(abdominaisFA.length > 0 || cardiosFA.length > 0 || exerciciosFA.length > 0){
    <button (click)="salvar()" class="btn btn-primary w-100 mt-3">
      Salvar Treino
    </button>
    }
  </ng-container>
</div>